export const requirementTitles = function (
  type: string,
  quantifier: number | undefined,
) {
  switch (type) {
    case 'company_accounts':
      return 'Upload latest company accounts';
    case 'bank_statement':
      return 'Link your business bank account to share statements';
    case 'vat_return': {
      const quarter = quantifier && quantifier / 3;
      if (quarter && quarter > 1) {
        return `Upload business VAT returns for the last ${quarter} quarters`;
      }
      return 'Upload business VAT returns for the last quarter';
    }
    case 'management_accounts':
      return 'Upload current management accounts';
    case 'business_plan':
      return 'Upload your business plan';
    case 'aged_debtor_report':
      return 'Upload your aged debtor report';
    default:
      break;
  }
};

export const requirementErrorMessages: Record<string, string> = {
  company_accounts: 'Please upload your company accounts before continuing.',
  vat_return: 'Please upload your VAT returns before continuing.',
  management_accounts:
    'Please upload your management accounts before continuing.',
  business_plan: 'Please upload your business plan before continuing.',
  aged_debtor_report:
    'Please upload your aged debtor report before continuing.',
  bank_statement:
    'Please link your bank account or upload statements before continuing.',
};
